<template>
  <lf-modal
    :title="$t('AI_AGENTS.DELETE_MODAL.TITLE')"
    :close="() => emit('close')"
    small
  >
    <template v-slot:content>
      <p class="px-6 pb-4 break-words text-gray-700">
        {{
          $t("AI_AGENTS.DELETE_MODAL.BODY", {
            name: agent?.name ?? "",
          })
        }}
      </p>
      <div class="flex justify-end border-t border-gray-200 p-6">
        <modal-buttons :on-cancel="() => emit('close')" :on-delete="submit" />
      </div>
    </template>
  </lf-modal>
</template>

<script setup lang="ts">
import { useAiAgentsStore } from "@/stores/ai/agents";

import LfModal from "@/components/ui/Modal.vue";
import ModalButtons from "@/components/ui/ModalButtons.vue";

import type { AiAgent } from "@/models/aiAgents";

const { agent } = defineProps<{
  agent: AiAgent;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { deleteById } = useAiAgentsStore();

const submit = async () => {
  if (!agent?.id) {
    return;
  }

  await deleteById(agent.id);
  emit("close");
};
</script>
